// src/types/properties/addressFieldsFor.ts
var IN_A_BUILDING = /* @__PURE__ */ new Set([
  "apartment" /* Apartment */,
  "studio" /* Studio */,
  "duplex" /* Duplex */,
  "penthouse" /* Penthouse */,
  "chalet" /* Chalet */
]);
var HOTEL_TYPES = /* @__PURE__ */ new Set([
  "hotel" /* Hotel */,
  "boutique_hotel" /* BoutiqueHotel */,
  "guesthouse" /* Guesthouse */
]);
var isHotelType = (propertyType) => HOTEL_TYPES.has(propertyType);
var addressFieldsFor = (propertyType) => {
  const inABuilding = IN_A_BUILDING.has(propertyType);
  return {
    building: true,
    floor: inABuilding,
    apartment: inABuilding,
    directions: true
  };
};
var isUnitInABuilding = (propertyType) => IN_A_BUILDING.has(propertyType);

export {
  isHotelType,
  addressFieldsFor,
  isUnitInABuilding
};
